// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "../layouts/application.css";
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "main"
import "sticky"
import "@fortawesome/fontawesome-free/css/all"
import "datatables.net"


import axios from 'axios'
import $ from 'jquery'
global.$ = jQuery

require('jquery-ui');
require("easy-autocomplete")

Rails.start()
ActiveStorage.start()
